// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1rD0s","right":"styles_right__3jyoU"};